import type { IFieldLayout } from './IFieldLayout';

const num = (v: unknown, fallback: number) => (typeof v === 'number' && Number.isFinite(v) ? v : fallback);

/**
 * Розміщення полів поверх базового (прототип v4 mergeGset): значення налаштування (глобальне або перевизначення простору — лише змінені
 * параметри) доповнює `base`; ширини зливаються за типами, порядок груп замінюється цілком (порожній — базовий). Чиста функція.
 */
export function mergeLayout(base: IFieldLayout, value: unknown): IFieldLayout {
  if (!value || typeof value !== 'object') return base;
  const v = value as Partial<Record<keyof IFieldLayout, unknown>>;
  const widths = v.widths && typeof v.widths === 'object' ? (v.widths as Record<string, string>) : {};
  const order = Array.isArray(v.groupOrder) && v.groupOrder.length ? (v.groupOrder as string[]) : base.groupOrder;
  return { unit: num(v.unit, base.unit), groupMin: num(v.groupMin, base.groupMin), longOption: num(v.longOption, base.longOption), groupOrder: order, widths: { ...base.widths, ...widths } };
}

/** Перевизначення простору: лише параметри, що відрізняються від глобальних (прототип v4 layoutOverride); нічого — порожній об'єкт. Чиста функція. */
export function layoutOverride(layout: IFieldLayout, base: IFieldLayout): Partial<IFieldLayout> {
  const out: Partial<IFieldLayout> = {};
  for (const k of ['unit', 'groupMin', 'longOption'] as const) if (layout[k] !== base[k]) out[k] = layout[k];
  const widths = Object.fromEntries(Object.entries(layout.widths).filter(([k, w]) => w !== base.widths[k]));
  if (Object.keys(widths).length) out.widths = widths;
  if (layout.groupOrder.join('|') !== base.groupOrder.join('|')) out.groupOrder = layout.groupOrder;
  return out;
}
